<div class="phone-section">
  <div class="logo-container">
    <img src="assets/logos/onlylogo.jpg" alt="onlylogo" class="only-logo" />
  </div>
  <div class="phone-content">
    <div class="phone-text">Want to speak live?</div>
    <a href="tel:1-833-316-1665" class="phone-number">
      <img src="assets/icons/phone.svg" alt="phone" class="phone-icon" />
      1-833-316-1665
    </a>
    <div class="availability">
      <span class="green-dot"></span>
      Expert Agents Available Now
    </div>
  </div>
</div> 